<template>
  <div v-if="wasHidden" :class="rootCss">
    <div
      @click="showFilters"
      class="d-inline-flex flex-row align-items-center filter-block__arrow_right"
    >
      <span class="arrow__text">Фильтры</span>
      <div>
        <i class="fa fa-arrow-right" />
      </div>
    </div>
  </div>
  <div
    v-else
    class="panel-heading with-appear-animation input-group custom-search-form filter-block"
  >
    <div
      @click="hideFilters"
      class="d-inline-flex align-items-center flex-row filter-block__arrow_left"
    >
      <div>
        <i class="fa fa-arrow-left" />
      </div>
      <span class="arrow__text">Скрыть</span>
    </div>
    <form
      @submit.prevent="searchItems"
      @reset="resetForm"
      class="filter-block__wrapper"
    >
      <div class="form__fields">
        <div v-if="!entitiesWithoutName">
          <div>
            <label class="control-label">{{ nameLabel }}</label>
            <input
              maxlength="80"
              class="form-control"
              id="name"
              v-model.trim="name"
            />
          </div>
        </div>
        <div v-for="field in addedCustomFields" :key="field.name">
          <div>
            <div>
              <label class="control-label">{{ field.title }}</label>
              <i
                class="fa fa-close button__icon_close"
                @click="removeCustomField(field)"
              />
            </div>
            <select v-if="field.selectOptions.length > 0" class="form-control" v-model="field.value">
              <option value="" default>Не выбрано</option>
              <option
                v-for="option in field.selectOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <input
              v-else
              maxlength="50"
              class="form-control"
              :type="field.type ? field.type : 'text'"
              id="name"
              v-model.trim="field.value"
            />
          </div>
        </div>
        <div>
          <div v-if="!withoutDateFilters">
            <div class="form-group__label_date">
              <label class="control-label" for="createdAt">
                {{ createdAtLabel }}
              </label>
              <div class="label__criterions">
                <select
                  v-model="isCreatedAtInterval"
                  class="criterions__select"
                >
                  <option :value="false">дата</option>
                  <option :value="true">диапазон</option>
                </select>
              </div>
            </div>
            <div
              :class="{ 'form-group__input_dates-range': isCreatedAtInterval }"
            >
              <input
                class="form-control"
                type="date"
                v-model="createdAt1"
                id="createdAt"
              />
              <input
                v-if="isCreatedAtInterval"
                class="form-control with-appear-animation"
                type="date"
                v-model="createdAt2"
              />
            </div>
          </div>
        </div>
        <div>
          <div v-if="!withoutDateFilters && !withoutUpdateDateFilter">
            <div class="form-group__label_date">
              <label class="control-label" for="createdAt"
                >Дата изменения</label
              >
              <div class="label__criterions">
                <select
                  v-model="isUpdatedAtInterval"
                  class="criterions__select"
                >
                  <option :value="false">дата</option>
                  <option :value="true">диапазон</option>
                </select>
              </div>
            </div>
            <div
              :class="{ 'form-group__input_dates-range': isUpdatedAtInterval }"
            >
              <input
                class="form-control"
                type="date"
                v-model="updatedAt1"
                id="updatedAt"
              />
              <input
                v-if="isUpdatedAtInterval"
                class="form-control with-appear-animation"
                type="date"
                v-model="updatedAt2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <slot name="custom-buttons"></slot>
      </div>
      <div class="form__buttons">
        <button
          class="btn btn-font btn-success buttons__button_search"
          type="submit"
          :disabled="!inputsWereChanged"
        >
          <i class="fa fa-filter"></i>
          Применить
        </button>
        <button
          v-if="filtersWereApplied"
          class="btn btn-danger btn-font buttons__button_reset"
          type="reset"
          @click="resetFilters"
        >
          <i class="fa fa-close"></i>
          Сбросить
        </button>
        <button
          v-if="customFieldsList.length > 0 && !allCustomFieldsAreAdded"
          class="btn btn-default btn-font btn-primary buttons__button_add-field"
          type="button"
          @click="toggleModal(true)"
        >
          <i class="fa fa-plus"></i>
          Добавить поля
        </button>
        <button
          v-if="addedCustomFields.length > 0"
          class="btn btn-default btn-font btn-danger buttons__button_delete-field"
          type="button"
          @click="addedCustomFields = []"
        >
          <i class="fa fa-eraser"></i>
          Удалить доп.поля
        </button>
      </div>
    </form>
    <CustomFieldsModal
      v-if="showModal"
      :already-added-fields="addedCustomFields"
      :fields-list="customFieldsList"
      @close="toggleModal(false)"
      @choose="chooseCustomFields"
    />
  </div>
</template>

<script>
import CustomFieldsModal from "@/_shared/components/modals/CustomFieldsModal";
import { useInputValidator } from "@/_shared/mixins";
export default {
  mixins: [useInputValidator],
  emits: ["on-reset-filters"],
  components: {
    CustomFieldsModal,
  },
  props: {
    customFieldsList: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    withoutDateFilters: {
      default: false,
    },
    withoutUpdateDateFilter: {
      default: false,
    },
    nameLabel: {
      from: 'nameFilterLabel',
      default: 'Название',
    },
    createdAtLabel: {
      from: 'createdAtFilterLabel',
      default: 'Дата создания',
    },
  },
  data() {
    return {
      withoutDateFilters: this.withoutDateFilters,
      withoutUpdateDateFilter: this.withoutUpdateDateFilter,
      nameLabel: this.nameLabel,
      createdAtLabel: this.createdAtLabel,
      filtersWereApplied: false,
      wasHidden: false,
      name: "",
      addedCustomFields: [],
      createdAt1: "",
      createdAt2: "",
      isCreatedAtInterval: false,
      updatedAt1: "",
      updatedAt2: "",
      isUpdatedAtInterval: false,
      showModal: false,
    };
  },
  computed: {
    rootCss() {
      return {
        "filter-form_disabled": this.disabled,
      };
    },
    inputsWereChanged() {
      const filterNames = [
        "name",
        "createdAt1",
        "createdAt2",
        "updatedAt1",
        "updatedAt2",
      ];
      let wereApplied = false;
      filterNames.forEach((name) => {
        let value = this[name].toString();
        if (value.length > 0) {
          wereApplied = true;
        }
      });
      this.addedCustomFields.forEach((field) => {
        let value = field.value.toString();
        if (value.length > 0) {
          wereApplied = true;
        }
      });
      return wereApplied;
    },
    allCustomFieldsAreAdded() {
      return !!(this.addedCustomFields.length === this.customFieldsList.length);
    },
    entitiesWithoutName() {
      const entities = [
        '/purchase_orders',
        '/login_history',
        '/stock_movement',
      ];
      return entities.includes(this.$route.path);
    },
  },
  methods: {
    removeCustomField(removingField = {}) {
      removingField.value = "";
      const results = this.addedCustomFields.filter(
        (field) => field.title !== removingField.title
      );
      this.addedCustomFields = results;
    },
    toggleModal(show) {
      this.showModal = show;
    },
    chooseCustomFields(fields) {
      const cleaningFields = fields.map((field) => ({
        title: field.title,
        name: field.name,
        value: "",
        type: field.type || null,
        selectOptions: field.selectOptions || [],
        modalName: field.modalName || null,
      }));
      this.addedCustomFields = [...this.addedCustomFields, ...cleaningFields];
      this.toggleModal(false);
    },
    showFilters() {
      this.wasHidden = false;
    },
    hideFilters() {
      this.resetFilters();
      this.wasHidden = true;
    },
    resetFilters() {
      this.addedCustomFields = [];
      if (this.filtersWereApplied) {
        this.$emit("on-reset-filters");
      }
      this.filtersWereApplied = false;
      this.resetForm();
    },
    resetForm() {
      this.name = "";
      this.createdAt1 = "";
      this.createdAt2 = "";
      this.updatedAt1 = "";
      this.updatedAt2 = "";
      this.isUpdatedAtInterval = false;
      this.isCreatedAtInterval = false;
    },
    searchItems() {
      const searchBody = [];

      this.name && searchBody.push({ name: this.name });
      this.isCreatedAtInterval && this.createdAt1 && this.createdAt2
        ? searchBody.push({ createdAt: [this.createdAt1, this.createdAt2] })
        : this.createdAt1
        ? searchBody.push({ createdAt: [this.createdAt1] })
        : null;
      this.isUpdatedAtInterval && this.updatedAt1 && this.updatedAt2
        ? searchBody.push({ updatedAt: [this.updatedAt1, this.updatedAt2] })
        : this.updatedAt1
        ? searchBody.push({ updatedAt: [this.updatedAt1] })
        : null;
      if (this.addedCustomFields.length > 0) {
        this.addedCustomFields.forEach((customField) => {
          const { name, value } = customField;
          if (value) {
            searchBody.push({ [name]: value });
          }
        });
      }
      this.filtersWereApplied = true;
      this.$emit("search", searchBody);
    },
  },
};
</script>

<style scoped>
.filter-form_disabled {
  pointer-events: none;
  opacity: 0.5;
}

.filter-block {
  width: 100%;
}

.criterions__select {
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.5);
  padding: 0 8px;
  border: 1px rgba(0, 0, 0, 0.5) solid;
}

.criterions__select:hover {
  transition: 0.3s;
  opacity: 0.8;
  cursor: pointer;
}

.criterions__select:focus {
  outline: none;
}

.form__fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  row-gap: 1.4em;
  column-gap: 0.8em;
  margin: 1.4em 0;
}

.filter-block__arrow_left:hover,
.filter-block__arrow_right:hover {
  opacity: 0.5;
  cursor: pointer;
}
.filter-block__arrow_right {
  margin: 1em 2em 0;
  display: inline-flex;
  column-gap: 0.5em;
}
.filter-block__arrow_left {
  margin-top: 0.5em;
  display: inline-flex;
  column-gap: 0.5em;
}
.arrow__text {
  display: inline-flex;
  align-items: center;
}

.form-group__label_date {
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.label__criterions {
  margin-bottom: 8px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.8em;
}

.criterions__criterion {
  white-space: nowrap;
}

.form-group__input_dates-range {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  column-gap: 0.2em;
}

.form__buttons {
  row-gap: 1em;
  column-gap: 1em;
  grid-template-columns: repeat(auto-fit, minmax(80px, 200px));
  display: grid;
}

@media (max-width: 1279px) {
  .form__fields {
    display: inline-flex;
    flex-direction: column;
    width: 100%;
  }
  .form__fields > *:not(:last-child) {
    margin-bottom: 0.8em;
  }
}

@media (max-width: 1023px) {
  .form__buttons {
    grid-template-columns: repeat(2, auto);
  }
}

@media (max-width: 419px) {
  .form__buttons {
    display: inline-flex;
    flex-direction: column;
    width: 100%;
  }
  .buttons__button_reset,
  .buttons__button_add-field,
  .buttons__button_delete-field {
    margin-top: 0.3em;
  }
  .form__fields > *:not(:last-child) {
    margin-bottom: 0;
  }
  .form-group__label_date {
    flex-direction: column;
  }
  .form-group__label_date > * {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/table/FilterForm.vue